import { Component, Input, OnInit } from '@angular/core';

import * as _ from 'lodash';
import * as d3 from 'd3';

import { TrackerRest } from '../../../../plugins/tracker/services/tracker.rest';
import { gfDateFunction } from '../../../pipes/date/date.functions';

@Component({
    selector: 'project-trackers',
    template: require('./project.trackers.component.html')
})
export class ProjectTrackersComponent implements OnInit {

    @Input() project: any = null;

    @Input() readOnly: any = false;

    protected showOpenByAssignee = false;
    private burndown: any = false;
    private burndownChartData = [];
    protected showBurndownChart = false;

    private trackerStatsData: any = null;
    private trackerStatsChartOptions: any = null;
    private burndownChartOptions: any = null;

    private tracker_stats: any = null;

    constructor(
        private trackerRest: TrackerRest,
    ) { }

    ngOnInit(): void {
        this.showOpenByAssignee = false;
        this.burndown = false;
        this.burndownChartData = [];
        this.showBurndownChart = false;

        this.trackerStatsChartOptions = {
            chart: {
                type: 'pieChart',
                height: 250,
                width: 250,
                x: (d) => d.key,
                y: (d) => d.y,
                showLabels: false,
                transitionDuration: 200,
                labelThreshold: 0.01,
                showLegend: false,
                tooltips: true,
                labelsOutside: true,
                margin: {
                    left: -40
                }
            }
        };

        this.burndownChartOptions = {
            chart: {
                type: 'multiChart',
                height: 250,
                margin: {
                    top: 1,
                    right: 1,
                    bottom: 1,
                   left: 1
                },
                showLegend: false,
                x: (d) => d.x,
                y: (d) => d.y,
                lines: {
                    xScale: d3.time.scale()
                },
                xAxis: {
                    tickFormat: (d) => gfDateFunction(d, 'dd/MM/yyyy')
                },
                transitionDuration: 1000
            }
        };
    }    

    private setup() {
        if (_.has(this.project, 'rel.trackers')) {
            this.project.rel.trackers = _.sortBy(
                _.filter(this.project.rel.trackers, function(item) {
                    return (item.is_public || item.access_level > 0);
                }),
                "tracker_name"
            );
        }

        if (this.project.rel && this.project.rel.trackers.length === 1) {
            this.trackerRest.fetch(this.project.rel.trackers[0].tracker_id, 
                'stats', 'type=count&group_by=assignee&statusId=1')
            .then((response) => {
                this.tracker_stats = response;

                var statValues = [];
                if (this.tracker_stats) {
                    for (var i = 0, l = this.tracker_stats.values.length; i < l; i++){
                        statValues[i] = {
                            key : this.tracker_stats.values[i].title,
                            y : this.tracker_stats.values[i].measure
                        };
                    }
                }
                this.trackerStatsData = statValues;
                this.showOpenByAssignee = (!_.isEmpty(this.trackerStatsData)) ? true : false;
            }, (response) => {
                this.tracker_stats = false;
            });

            this.trackerRest.fetch(this.project.rel.trackers[0].tracker_id, 'stats', 'type=burndown')
            .then((response) => {
                this.burndown = response;

                if (this.burndown.values && this.burndown.values.bins) {
                    this.burndownChartData = this.getBurndownData(this.burndown.values.bins);
                    this.showBurndownChart = (this.burndownChartData?.length > 0) ? true : false;
                }
            }, (response) => {
                this.burndown = false;
            });
        }
    }

    private getBurndownData(bins) {
        var burndownValue = {};
        for (var key in bins) {
            for (var key2 in bins[key]){
                if ( (key2 != 'pre') && (key2 != 'net')) {
                    if (!_.has(burndownValue, key2)) {
                        burndownValue[key2] = [];
                    }
                    if ((key2 == 'closed')) {
                        bins[key][key2] = bins[key][key2] * -1;
                    }
                    var dt = new Date(key + 'T00:00:00');
                    var ticks = dt.getTime() + (dt.getTimezoneOffset() * 60000);
                    burndownValue[key2].push({
                        x: new Date(ticks),
                        y: bins[key][key2]
                    });
                }
            }
        }
        var burndown = [];
        var type;
        for (var val in burndownValue){
            (val == 'post') ? type = 'line' : type = 'bar';
            burndown.push({
                'key' : val,
                'type' : type,
                'yAxis': 1,
                'values' : burndownValue[val]
            });
        }
        return burndown;
    }
}